let TaskPlanTable = [{
  label: "序号",
  prop: "taskId",
  sortable: 1
},
{
  label: "任务分类",
  prop: "categoryName"
},
{
  label: "责任人",
  prop: "respPerson"
},
{
  label: "工作内容",
  prop: "taskDetail"
},
{
  label: "评价标准",
  prop: "evaCriterion"
},
{
  label: "分值",
  prop: "totalScore"
},
{
  label: "任务类型",
  prop: "taskType"
},
{
  label: "要求完成时限",
  prop: "endDate"
},
{
  label: "是否完成",
  prop: "accomplish"
},
{
  label: "完成时间",
  prop: "accomplishDate"
},
// {
//   label: "完成时效",
//   prop: "accomplishTimeRatio"
// },
{
  label: "完成比例",
  prop: "accomplishRatio"
},
{
  label: "完成情况",
  prop: "accomplishDetail"
},
]


let TaskPlanHistoryTable = [{
  label: "序号",
  prop: "taskId",
  sortable: 1
},
{
  label: "业务类型",
  prop: "planType"
},
{
  label: "年度",
  prop: "year"
},
{
  label: "季度",
  prop: "season"
},
{
  label: "月份",
  prop: "month"
},
{
  label: "填报时间",
  prop: "date"
},
{
  label: "报告名称",
  prop: "title"
},
{
  label: "负责人",
  prop: "name"
},
{
  label: "审批状态",
  prop: "state"
},
{
  label: "审批意见",
  prop: "advice"
},
]

export {
  TaskPlanTable,
  TaskPlanHistoryTable
}